module.exports = __webpack_public_path__ + "static/media/Pug Costume Guy.1f923d8a.jpg";